import { useEffect, useState, useContext, useRef } from 'react'
import './orderPriceDetails.css'
import { ReactComponent as GipLogoSvg } from '../../img/gipLogoSvg.svg'
import { ReactComponent as SimplixLogoSvg } from '../../img/simplixLogoSvg.svg'

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import ResponseModal from './responseModal';

import { CgClose } from 'react-icons/cg';
import { MdOutlineStickyNote2 } from 'react-icons/md';
import { MdOutlineEditRoad } from 'react-icons/md';
import { TbTableExport } from 'react-icons/tb';
import { VscDebugRestart } from 'react-icons/vsc';

export default function OrderPriceDetails(props) {
    console.log(props);
    const [order, setOrder] = useState([]);
    const [orderBackup, setOrderBackup] = useState([]);
    const [orderNumber, setOrderNumber] = useState("Não definido");
    const [orderReference, setOrderReference] = useState(null);
    const [orderCompany, setOrderCompany] = useState("Não definida");
    const [orderEmail, setOrderEmail] = useState("Não definido");
    const [orderDate, setOrderDate] = useState("Não definida");

    const [fillIcms, setFillIcms] = useState("0,00%")
    const [fillIpi, setFillIpi] = useState("0,00%")
    const [fillPis, setFillPis] = useState("0,00%")
    const [fillCofins, setFillCofins] = useState("0,00%")
    const [fillDeliverDate, setFillDeliverDate] = useState(null)

    const [showSendModal, setShowSendModal] = useState(false)
    const [showResetModal, setShowResetModal] = useState(false)
    const [showObsVendModal, setShowObsVendModal] = useState(false)
    const [showObsCompModal, setShowObsCompModal] = useState(false)

    const [obsMatServ, setObsMatServ] = useState(false)
    const [obsCodMatServ, setObsCodMatServ] = useState(false)
    const [obsIndex, setObsIndex] = useState(false)

    const [showResponseModal, setShowResponseModal] = useState(false)
    const [responseModalMessage, setResponseModalMessage] = useState(0)
    const [responseModalType, setResponseModalType] = useState(0)

    const [totalPriceGI, setTotalPriceGI] = useState(0)
    const [totalPecasGI, setTotalPecasGI] = useState(0)
    const [finalDateGI, setFinalDateGI] = useState("Não definida")

    const [openedObservationBox, setOpenedObservationBox] = useState(false)

    const [generalDiscount, setGeneralDiscount] = useState("R$ 0,0000");
    const [generalTransport, setGeneralTransport] = useState("R$ 0,0000");
    const [generalInsurance, setGeneralInsurance] = useState("R$ 0,0000");
    const [generalOther, setGeneralOther] = useState("R$ 0,0000");
    const [generalPayCond, setGeneralPayCond] = useState(null);
    const [generalPayCondArray, setGeneralPayCondArray] = useState([]);
    const [generalTransType, setGeneralTransType] = useState(null);
    const [generalTransTypeArray, setGeneralTransTypeArray] = useState([]);

    const [observation, setObservation] = useState("")
    const [editingMoney, setEditingMoney] = useState({ row: null, field: null });

    const isEditing = (row, field) =>
        editingMoney.row === row && editingMoney.field === field;

    const safeNumber = (value) => {
        if (value === null || value === undefined || value === "") return 0;
        const n = Number(value);
        return Number.isFinite(n) ? n : 0;
    };

    const toEditBR = (n) => {
        const v = safeNumber(n);
        return v.toFixed(2).replace(".", ",");
    };

    const normalizeNumberInput = (v) =>
        v
            .replace(/[^0-9.,]/g, "")
            .replace(/(,.*),/g, "$1")
            .replace(/(\..*)\./g, "$1");

    const parseMoney = (v) => {
        if (v == null) return 0;
        if (typeof v === "number") return Number.isFinite(v) ? v : 0;

        let s = String(v).trim();
        if (s === "") return 0;

        s = s.replace(/R\$\s?/g, "").replace(/\s/g, "");

        s = s.replace(/[^0-9.,-]/g, "");

        const lastComma = s.lastIndexOf(",");
        const lastDot = s.lastIndexOf(".");
        const decPos = Math.max(lastComma, lastDot);

        let normalized;
        if (decPos >= 0) {
            const intPart = s.slice(0, decPos).replace(/[.,]/g, "");
            const decPart = s.slice(decPos + 1).replace(/[.,]/g, "");
            normalized = `${intPart}.${decPart}`;
        } else {
            normalized = s.replace(/[.,]/g, "");
        }

        const n = Number(normalized);
        return Number.isFinite(n) ? n : 0;
    };


    const toBRL = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const parsePercent = v =>
  Number(
    v
      .replace('%', '')
      .replace('.', '')
      .replace(',', '.')
  ) / 100

    useEffect(() => {
        let auxOrder = structuredClone(props?.data?.orderData?.Itens);
        let totalPecasAuxGI = 0;
        let totalPriceAuxGI = 0;
        let finalDateAuxGI = new Date("0001-01-01T00:00:00");

        auxOrder?.forEach(element => {

            const quantidade = parseFloat(element?.QuantidadeUM ?? 0) || 0;
            const valorUnitario = parseFloat(element?.ValorUnitario ?? 0) || 0;
            const valorDesconto = parseFloat(element?.ValorDescontoItem ?? 0) || 0;

            const ipiFrac = parsePercentToFraction(element?.PercentualIpi);

            const bruto = quantidade * valorUnitario;
            const liquido = Math.max(0, bruto - valorDesconto);
            const totalComIpi = liquido + (liquido * ipiFrac);

            element.ValorTotalImp = totalComIpi.toFixed(5);

            element.ValorTotal = toBRL.format(liquido);
            element.ValorDesconto = toBRL.format(valorDesconto);

            if (element.ValorUnitario != null) {
                element.ValorUnitario = toBRL.format(valorUnitario);
            } else {
                element.ValorUnitario = "R$ 0,00000";
            }

            if (element.PercentualIcms != null) {
                element.PercentualIcms = `${(parseFloat(element.PercentualIcms) * 100).toFixed(2).replace(".", ",")}%`;
            }
            if (element.PercentualIpi != null) {
                element.PercentualIpi = `${(parseFloat(element.PercentualIpi) * 100).toFixed(2).replace(".", ",")}%`;
            }
            if (element.PercentualPis != null) {
                element.PercentualPis = `${(parseFloat(element.PercentualPis) * 100).toFixed(2).replace(".", ",")}%`;
            }
            if (element.PercentualCofins != null) {
                element.PercentualCofins = `${(parseFloat(element.PercentualCofins) * 100).toFixed(2).replace(".", ",")}%`;
            }

            totalPecasAuxGI += parseFloat(element?.QuantidadePcs ?? 0);
            totalPriceAuxGI += totalComIpi;

            if (element.DataEntrega) {
                const elementFinalDate = new Date(element.DataEntrega);
                if (elementFinalDate > finalDateAuxGI) {
                    finalDateAuxGI = elementFinalDate;
                }
            }
        });

        if (finalDateAuxGI.getFullYear().toString() !== "1") {
            setFinalDateGI(
                `${finalDateAuxGI.getDate()}/${finalDateAuxGI.getMonth() + 1}/${finalDateAuxGI.getFullYear()}`
            );
        }

        setTotalPriceGI(toBRL.format(totalPriceAuxGI));
        setTotalPecasGI(totalPecasAuxGI);
        setOrder(structuredClone(auxOrder));
        setOrderBackup(structuredClone(auxOrder));

        if (props?.data?.orderData?.ReferenciaFornecedor != null)
            setOrderReference(props.data.orderData.ReferenciaFornecedor);

        if (props?.data?.orderData?.Cotacao != null)
            setOrderNumber(props.data.orderData.Cotacao);

        if (props?.data?.orderData?.Empresa != null)
            setOrderCompany(props.data.orderData.Empresa);

        if (props?.data?.orderData?.Email != null)
            setOrderEmail(props.data.orderData.Email);

        if (props?.data?.orderData?.DataCotacao != null) {
            const orderDate = props.data.orderData.DataCotacao.split('T')[0];
            setOrderDate(`${orderDate.split('-')[2]}/${orderDate.split('-')[1]}/${orderDate.split('-')[0]}`);
        }

        if (props?.data?.orderData?.CondPagamento != null)
            setGeneralPayCond(props.data.orderData.CondPagamento);

        setGeneralPayCondArray(props?.data?.orderData?.RegistrosAdicionais?.CondicoesPagamentos ?? []);

        if (props?.data?.orderData?.CdFrete != null)
            setGeneralTransType(props.data.orderData.CdFrete);

        setGeneralTransTypeArray(props?.data?.orderData?.RegistrosAdicionais?.TiposFrete ?? []);

        setObservation(props?.data?.orderData?.Observacoes ?? "");

        setGeneralDiscount(toBRL.format((props?.data?.orderData?.VlDesconto ?? 0).toFixed(2)));
        setGeneralTransport(toBRL.format((props?.data?.orderData?.VlFrete ?? 0).toFixed(2)));
        setGeneralInsurance(toBRL.format((props?.data?.orderData?.VlSeguro ?? 0).toFixed(2)));
        setGeneralOther(toBRL.format((props?.data?.orderData?.VlOutrasDespesas ?? 0).toFixed(2)));

    }, []);


    useEffect(() => {
        if (order?.length > 0) {
            let auxOrder = structuredClone(order)
            auxOrder?.map((element) => {
                if (countChar(fillIcms.toString(), "%") == 0) {
                    element.PercentualIcms = fillIcms == "" || fillIcms == 0 ? parseFloat(0).toFixed(2) : parseFloat(fillIcms).toFixed(2)
                }
                else {
                    element.PercentualIcms = fillIcms
                }
                if (countChar(element.PercentualIpi.toString(), "%") == 0) {
                    element.PercentualIpi = `${parseFloat(element.PercentualIpi).toFixed(2).toString().replace(".", ",")}%`
                }
            })
            setOrder(auxOrder)
        }
    }, [fillIcms])

    useEffect(() => {
        if (!order || order.length === 0) return;

        const auxOrder = structuredClone(order);

        auxOrder.forEach((element) => {
            const liquido = parseBRL(element.ValorTotal);

            const ipiFrac = parsePercentToFraction(fillIpi);

            element.ValorTotalImp = (liquido + (liquido * ipiFrac)).toFixed(5);

            if (countChar(fillIpi.toString(), "%") === 0) {
                const ipiNum = isNaN(parseFloat(fillIpi)) ? 0 : parseFloat(fillIpi);
                element.PercentualIpi = `${ipiNum.toFixed(2).replace(".", ",")}%`;
            } else {
                element.PercentualIpi = fillIpi;
            }

            if (countChar(element.PercentualIcms?.toString() ?? "", "%") === 0) {
                const icmsNum = parseFloat(element.PercentualIcms) || 0;
                element.PercentualIcms = `${icmsNum.toFixed(2).replace(".", ",")}%`;
            }
        });

        setOrder(auxOrder);
    }, [fillIpi]);


    useEffect(() => {
        if (order?.length > 0) {
            let auxOrder = structuredClone(order)
            auxOrder?.map((element) => {
                if (countChar(fillPis.toString(), "%") == 0) {
                    element.PercentualPis = fillPis == "" || fillPis == 0 ? parseFloat(0).toFixed(2) : parseFloat(fillPis).toFixed(2)
                }
                else {
                    element.PercentualPis = fillPis
                }
                if(countChar(element.PercentualIcms.toString(),"%") == 0){
                    element.PercentualIcms = `${parseFloat(element.PercentualIcms).toFixed(2).toString().replace(".",",")}%`
                }
                if(countChar(element.PercentualIpi.toString(),"%") == 0){
                    element.PercentualIpi = `${parseFloat(element.PercentualIpi).toFixed(2).toString().replace(".",",")}%`
                }
                if(countChar(element.PercentualCofins.toString(),"%") == 0){
                    element.PercentualCofins = `${parseFloat(element.PercentualCofins).toFixed(2).toString().replace(".",",")}%`
                }
            })
            setOrder(auxOrder)
        }
    }, [fillPis])

    useEffect(() => {
        if (order?.length > 0) {
            let auxOrder = structuredClone(order)
            auxOrder?.map((element) => {
                if (countChar(fillCofins.toString(), "%") == 0) {
                    element.PercentualCofins = fillCofins == "" || fillCofins == 0 ? parseFloat(0).toFixed(2) : parseFloat(fillCofins).toFixed(2)
                }
                else {
                    element.PercentualCofins = fillCofins
                }
                if(countChar(element.PercentualIcms.toString(),"%") == 0){
                    element.PercentualIcms = `${parseFloat(element.PercentualIcms).toFixed(2).toString().replace(".",",")}%`
                }
                if(countChar(element.PercentualIpi.toString(),"%") == 0){
                    element.PercentualIpi = `${parseFloat(element.PercentualIpi).toFixed(2).toString().replace(".",",")}%`
                }
                if(countChar(element.PercentualPis.toString(),"%") == 0){
                    element.PercentualPis = `${parseFloat(element.PercentualPis).toFixed(2).toString().replace(".",",")}%`
                }
            })
            setOrder(auxOrder)
        }
    }, [fillCofins])

    useEffect(() => {
        if (order?.length > 0) {
            let auxOrder = structuredClone(order)
            auxOrder?.map((element) => {
                element.DataEntrega = fillDeliverDate
            })
            setOrder(auxOrder)
        }
    }, [fillDeliverDate])

    function parseBRL(v) {
        if (v == null) return 0;
        if (typeof v === "number") return v;

        const s = v.toString()
            .replace("R$", "")
            .trim();

        if (s === "") return 0;

        const normalized = s
            .replaceAll(".", "")
            .replace(",", ".");

        const n = parseFloat(normalized);
        return isNaN(n) ? 0 : n;
    }

    function parsePercentToFraction(v) {
        if (v == null) return 0;
        if (typeof v === "number") return v / 100;

        let s = v.toString().trim().replace("%", "").replaceAll(" ", "");
        if (s === "") return 0;

        if (s.includes(",")) {
            s = s.replaceAll(".", "").replace(",", ".");
        }

        const n = parseFloat(s);
        return isNaN(n) ? 0 : n / 100;
    }


    async function sendOrderDetails() {
        let itens = []
        order?.map(element => {
            itens.push(
                {
                    "Id": element.Id,
                    "QuantidadeUM": element.QuantidadeUM,
                    "DataNecessidade": element.DataNecessidade,
                    "ValorUnitario": parseMoney(element.ValorUnitario),
                    "ValorDescontoItem": parseMoney(element.ValorDesconto),
                    "ValorTotal": parseMoney(element.ValorTotal),
                    "PercentualIcms": parsePercent(element.PercentualIcms),
                    "PercentualIpi": parsePercent(element.PercentualIpi),
                    "PercentualPis": parsePercent(element.PercentualPis),
                    "PercentualCofins": parsePercent(element.PercentualCofins),
                    "DimensaoCot": element.DimensaoCot,
                    "DataEntrega": element.DataEntrega,
                    "ObservacoesItemVend": element.ObservacoesItemVend
                }
            )
        })
        console.log(order)
        console.log(itens, orderReference, generalDiscount, generalTransport, generalInsurance, generalOther, generalPayCond, generalTransType, observation)
        try {
            fetch('https://gipapi.azurewebsites.net/compras/cotacoes', {
            //fetch('https://localhost:44303/compras/cotacoes', {
                method: "PUT",
                headers: {
                    'access_token': props?.data?.key,
                    'Content-type': 'application/json; charset=UTF-8',
                },
                body: JSON.stringify({
                    Cotacao: orderNumber,
                    Itens: itens,
                    ReferenciaFornecedor: orderReference,
                    VlDesconto: parseFloat(generalDiscount.replace("R$", "").replaceAll(".", "").replaceAll(",", ".")),
                    VlFrete: parseFloat(generalTransport.replace("R$", "").replaceAll(".", "").replaceAll(",", ".")),
                    VlSeguro: parseFloat(generalInsurance.replace("R$", "").replaceAll(".", "").replaceAll(",", ".")),
                    VlOutrasDespesas: parseFloat(generalOther.replace("R$", "").replaceAll(".", "").replaceAll(",", ".")),
                    CondPagamento: parseInt(generalPayCond),
                    CdFrete: parseFloat(generalTransType),
                    Observacoes: observation
                })
            })
                .then((response) => {
                    setShowSendModal(false)
                    if (response.ok) {
                        setResponseModalMessage("Cotação enviada com sucesso!")
                        setResponseModalType(1)
                    }
                    else {
                        setResponseModalMessage("Um erro ocorreu no envio da cotação!")
                        setResponseModalType(0)
                    }
                    setShowResponseModal(true)
                })
                .catch((err) => {
                    console.log(err.message);
                });
        }
        catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        checkGeneralInfo()
        checkGeneralInputInfo()
    }, [order])

    useEffect(() => {
        checkGeneralInputInfo()
    }, [generalDiscount, generalTransport, generalInsurance, generalOther])

    function checkGeneralInfo() {
        let totalPriceAuxGI = 0
        let finalDateAuxGI = new Date("0001-01-01T00:00:00")
        order?.map((element) => {
            totalPriceAuxGI = totalPriceAuxGI + parseFloat(element.ValorTotalImp)

            if (element.DataEntrega != null && element.DataEntrega != undefined) {
                let elementFinalDate = new Date(structuredClone(element.DataEntrega))
                if (elementFinalDate > finalDateAuxGI) {
                    finalDateAuxGI = elementFinalDate
                }
            }
        })
        setTotalPriceGI(toBRL.format(totalPriceAuxGI))
        if (finalDateAuxGI.getFullYear().toString() != "1") {
            setFinalDateGI(`${finalDateAuxGI.getDate()}/${finalDateAuxGI.getMonth() + 1}/${finalDateAuxGI.getFullYear()}`)
        }
    }

    function checkGeneralInputInfo() {
        let totalItensComIpi = 0;
        let descontoItensTotal = 0;

        let generalTransportAux = 0;
        let generalInsuranceAux = 0;
        let generalOtherAux = 0;

        order?.forEach((element) => {
            totalItensComIpi += parseFloat(element?.ValorTotalImp ?? 0);
            descontoItensTotal += parseBRL(element?.ValorDesconto);
        });

        generalTransportAux = parseBRL(generalTransport);

        generalInsuranceAux = parseBRL(generalInsurance);

        generalOtherAux = parseBRL(generalOther);

        setGeneralDiscount(toBRL.format(descontoItensTotal));

        const totalFinal =
            totalItensComIpi
            // - descontoItensTotal
            + generalTransportAux
            + generalInsuranceAux
            + generalOtherAux;

        setTotalPriceGI(toBRL.format(totalFinal));
    }


    function exportCsv() {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        let fileName = `cotacao_pedido${orderNumber}`

        let orderAux = structuredClone(order)
        orderAux.map((element) => {
            let deliverDateAux = new Date(element.DataEntrega)
            element.DataEntrega = `${deliverDateAux.getDate()}/${deliverDateAux.getMonth() + 1}/${deliverDateAux.getFullYear()}`
            element.ValorTotalImp = toBRL.format(parseFloat(element.ValorTotalImp.toFixed(2)))
        })

        const ws = XLSX.utils.json_to_sheet(orderAux);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    function resetTable() {
        setOrder(structuredClone(orderBackup))
        setShowResetModal(false)
    }

    function countChar(string, char) {
        let count = 0
        string.split("").forEach((charAux) => {
            if (charAux == char) {
                count++
            }
        })
        return count
    }

    return (
        <div className='containerGlobalOrderPrice'>
            <div className='containerHeaderOrderPrice'>
                <div className='containerLogoOrderPrice'>
                    <GipLogoSvg className="gipLogoOrderPrice" height="45" width="90" style={{}} />
                    <SimplixLogoSvg className="simplixLogoOrderPrice" style={{}} />
                </div>
                <div className='headerOrderPrice'>Cotação de Pedido</div>
            </div>
            <div className='containerOrderDetailsOrderPrice'>
                <div className='containerDifDetailOrderPrice'>
                    <div className='containerDetailOrderPrice'>
                        <div className='detailFieldOrderPrice'>Referência:</div>
                        <div className='detailInfoOrderPrice'>
                            <input type="text"
                                className='detailInputItemListOrderPrice'
                                value={orderReference !== null && orderReference !== "" ? orderReference : "Não definido"}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    let value = e.target.value
                                    setOrderReference(value)
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className='containerDetailOrderPrice'>
                    <div className='detailFieldOrderPrice'>Pedido número:</div>
                    <div className='detailInfoOrderPrice'>{orderNumber}</div>
                </div>
                <div className='containerDetailOrderPrice'>
                    <div className='detailFieldOrderPrice'>Empresa:</div>
                    <div className='detailInfoOrderPrice'>{orderCompany}</div>
                </div>
                <div className='containerDetailOrderPrice'>
                    <div className='detailFieldOrderPrice'>E-mail:</div>
                    <div className='detailInfoOrderPrice'>{orderEmail}</div>
                </div>
                <div className='containerDetailOrderPrice'>
                    <div className='detailFieldOrderPrice'>Data de emissão:</div>
                    <div className='detailInfoOrderPrice'>{orderDate}</div>
                </div>
            </div>
            <div className='containerOrderOrderPrice'>
                <div className='containerOrderItensOrderPrice'>
                    <div></div>
                    <div className='orderItensOrderPrice'>Pedido</div>
                    <div className='containerMiscFuncOrderPrice'>
                        <div className='containerMiscButtonOrderPrice'>
                            <button className='miscButtonOrderPrice' onClick={() => { setShowResetModal(true) }}>
                                <VscDebugRestart className='miscIconOrderPrice' size={18} />
                                <div className='miscTextOrderPrice'>Resetar</div>
                            </button>
                        </div>
                        <div className='containerMiscButtonOrderPrice'>
                            <button className='miscButtonOrderPrice' onClick={() => { exportCsv() }}>
                                <TbTableExport className='miscIconOrderPrice' size={18} />
                                <div className='miscTextOrderPrice'>Exportar</div>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='containerItemListOrderPrice'>
                    <table className='tableItemListOrderPrice'>
                        <thead>
                            <tr className='containerFillItensOrderPrice'>
                                <th className='headerFillItemItemListOrderPrice headerFillDisclaimerItemItemListOrderPrice'>
                                    <MdOutlineEditRoad className="fillIconOrderPrice" size={30} />
                                    <div className="FillDisclaimerTextOrderPrice">Preenchimento<br />automático</div>
                                </th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'>
                                    <input type="text"
                                        className='rowInputItemListOrderPrice'
                                        value={fillIcms}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                            let value = e.target.value
                                            setFillIcms(value)
                                        }}
                                        onFocus={(e) => {
                                            setFillIcms(parseFloat(fillIcms.replace("%", "").replaceAll('.', '').replaceAll(',', '.')))
                                        }}
                                        onBlur={(e) => {
                                            let value = e.target.value
                                            let fillIcmsAux = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
                                            setFillIcms(`${fillIcmsAux.toFixed(2).replace(".", ",")}%`)
                                        }}
                                    />
                                </th>
                                <th className='headerFillItemItemListOrderPrice'>
                                    <input type="text"
                                        className='rowInputItemListOrderPrice'
                                        value={fillIpi}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                            let value = e.target.value
                                            setFillIpi(value)
                                        }}
                                        onFocus={(e) => {
                                            setFillIpi(parseFloat(fillIpi.replace("%", "").replaceAll('.', '').replaceAll(',', '.')))
                                        }}
                                        onBlur={(e) => {
                                            let value = e.target.value
                                            let fillIpiAux = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
                                            setFillIpi(`${fillIpiAux.toFixed(2).replace(".", ",")}%`)
                                        }}
                                    />
                                </th>
                                <th className='headerFillItemItemListOrderPrice'>
                                    <input type="text"
                                        className='rowInputItemListOrderPrice'
                                        value={fillPis}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                            let value = e.target.value
                                            setFillPis(value)
                                        }}
                                        onFocus={(e) => {
                                            setFillPis(parseFloat(fillPis.replace("%", "").replaceAll('.', '').replaceAll(',', '.')))
                                        }}
                                        onBlur={(e) => {
                                            let value = e.target.value
                                            let fillPisAux = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
                                            setFillPis(`${fillPisAux.toFixed(2).replace(".", ",")}%`)
                                        }}
                                    />
                                </th>
                                <th className='headerFillItemItemListOrderPrice'>
                                    <input type="text"
                                        className='rowInputItemListOrderPrice'
                                        value={fillCofins}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                            let value = e.target.value
                                            setFillCofins(value)
                                        }}
                                        onFocus={(e) => {
                                            setFillCofins(parseFloat(fillCofins.replace("%", "").replaceAll('.', '').replaceAll(',', '.')))
                                        }}
                                        onBlur={(e) => {
                                            let value = e.target.value
                                            let fillCofinsAux = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
                                            setFillCofins(`${fillCofinsAux.toFixed(2).replace(".", ",")}%`)
                                        }}
                                    />
                                </th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                                <th className='headerFillItemItemListOrderPrice'>
                                    <input className='rowInputDateItemListOrderPrice' type='date'
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.target.blur();
                                            }
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value != "" && e.target.value != null) {
                                                setFillDeliverDate(`${e.target.value}T00:00:00`)
                                            }
                                        }} />
                                </th>
                                <th className='headerFillItemItemListOrderPrice'></th>
                            </tr>
                        </thead>

                        <thead>
                            <tr>
                                <th className='headerItemItemListOrderPriceLeft'>Material/Serviço</th>
                                <th className='headerItemItemListOrderPriceCenter'>Cód. Mat./Serv.</th>
                                <th className='headerItemItemListOrderPriceCenter'>Proj./Pos.</th>
                                <th className='headerItemItemListOrderPriceRight'>Qtde/Pçs</th>
                                <th className='headerItemItemListOrderPriceRight'>Qtde</th>
                                <th className='headerItemItemListOrderPriceLeft'>UM</th>
                                <th className='headerItemItemListOrderPriceLeft'>Dimensão</th>
                                <th className='headerItemItemListOrderPriceCenter'>Necessidade</th>
                                <th className='headerItemItemListOrderPriceCenter'>Obs</th>
                                <th className='headerItemItemListOrderPriceRight'>Vlr Unitário</th>
                                <th className='headerItemItemListOrderPriceRight'>Vlr Desconto</th>
                                <th className='headerItemItemListOrderPriceRight'>Vlr Total</th>
                                <th className='headerItemItemListOrderPriceRight'>% ICMS</th>
                                <th className='headerItemItemListOrderPriceRight'>% IPI</th>
                                <th className='headerItemItemListOrderPriceRight'>% PIS</th>
                                <th className='headerItemItemListOrderPriceRight'>% COFINS</th>
                                <th className='headerItemItemListOrderPriceLeft'>Dimensão</th>
                                <th className='headerItemItemListOrderPriceCenter'>Data Entrega</th>
                                <th className='headerItemItemListOrderPriceCenter'>Obs</th>
                            </tr>
                        </thead>

                        <tbody>
                            {order?.map((element, index) => {
                                return (
                                    <tr key={"order" + index}>
                                        <td className='rowItemItemListOrderPrice' style={{ textAlign: "left" }}>{element?.Descricao}</td>
                                        <td className='rowItemItemListOrderPrice' style={{ textAlign: "center" }}>{element?.Codigo}</td>
                                        <td className='rowItemItemListOrderPrice' style={{ textAlign: "center" }}>{element?.ProjPosItem}</td>
                                        <td className='rowItemItemListOrderPrice'>{element?.QuantidadePcs?.toFixed(2)}</td>
                                        <td className='rowItemItemListOrderPrice'>{element?.QuantidadeUM?.toFixed(2)}</td>
                                        <td className='rowItemItemListOrderPrice'>{element?.UnidMedida}</td>
                                        <td className='rowItemItemListOrderPrice' style={{ textAlign: "left" }}>{element?.DimensaoPed}</td>
                                        <td className='rowItemItemListOrderPrice' style={{ textAlign: "center" }}>{element?.DataNecessidade ? new Date(element.DataNecessidade).toLocaleDateString('pt-BR') : "Não definida"}</td>
                                        <td className='rowItemIconListOrderPrice'>
                                            <div
                                                className='containerIconExpandObsOrderPrice'
                                                title='Expandir observações do comprador'
                                                onClick={() => {
                                                    setShowObsCompModal(true)
                                                    setObsMatServ(element?.Descricao)
                                                    setObsCodMatServ(element?.Codigo)
                                                    setObsIndex(index)
                                                }}>
                                                <MdOutlineStickyNote2 size={18} />
                                            </div>
                                        </td>

                                        {/* VLR UNITÁRIO */}
                                        <td>
                                            <input
                                                type="text"
                                                disabled={element?.UnidMedida === "UN" || element?.UnidMedida === "PC" ? false : true}
                                                style={{
                                                    border: element?.UnidMedida === "UN" || element?.UnidMedida === "PC" ? "" : "1px solid transparent",
                                                    width: "5rem"
                                                }}
                                                className="rowInputMonetaryListOrderPrice"
                                                value={element.ValorUnitario ?? "R$ 0,00"}
                                                onChange={(e) => {
                                                    e.target.value = normalizeNumberInput(e.target.value);

                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorUnitario = e.target.value;
                                                    setOrder(orderAux);
                                                }}
                                                onFocus={(e) => {
                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorUnitario =
                                                        parseMoney(e.target.value).toString().replace(".", ",");
                                                    setOrder(orderAux);
                                                }}
                                                onBlur={(e) => {
                                                    const value = parseMoney(e.target.value);

                                                    const qty = safeNumber(order[index].QuantidadeUM);
                                                    const desconto = parseMoney(order[index].ValorDesconto);

                                                    const bruto = qty * value;
                                                    const liquido = Math.max(0, bruto - desconto);

                                                    const ipiFrac = parsePercentToFraction(order[index].PercentualIpi);

                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorUnitario = `R$ ${value.toFixed(2).replace(".", ",")}`;
                                                    orderAux[index].ValorTotal = `R$ ${liquido.toFixed(2).replace(".", ",")}`;
                                                    orderAux[index].ValorTotalImp = (liquido + liquido * ipiFrac).toFixed(5);

                                                    setOrder(orderAux);
                                                }}
                                            />
                                        </td>

                                        {/* VLR DESCONTO */}
                                        <td>
                                            <input
                                                type="text"
                                                className="rowInputMonetaryListOrderPrice"
                                                style={{ width: "5rem", textAlign: "right" }}
                                                value={element.ValorDesconto ?? "R$ 0,00"}
                                                onChange={(e) => {
                                                    e.target.value = normalizeNumberInput(e.target.value);

                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorDesconto = e.target.value;
                                                    setOrder(orderAux);
                                                }}
                                                onFocus={(e) => {
                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorDesconto =
                                                        parseMoney(e.target.value).toString().replace(".", ",");
                                                    setOrder(orderAux);
                                                }}
                                                onBlur={(e) => {
                                                    const desconto = parseMoney(e.target.value);

                                                    const qty = safeNumber(order[index].QuantidadeUM);
                                                    const unit = parseMoney(order[index].ValorUnitario);
                                                    const bruto = qty * unit;
                                                    const liquido = Math.max(0, bruto - desconto);

                                                    const ipiFrac = parsePercentToFraction(order[index].PercentualIpi);

                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorDesconto = `R$ ${desconto.toFixed(2).replace(".", ",")}`;
                                                    orderAux[index].ValorTotal = `R$ ${liquido.toFixed(2).replace(".", ",")}`;
                                                    orderAux[index].ValorTotalImp = (liquido + liquido * ipiFrac).toFixed(5);

                                                    setOrder(orderAux);
                                                }}
                                            />
                                        </td>

                                        {/* VLR TOTAL */}
                                        <td>
                                            <input
                                                type="text"                                             
                                                className="rowInputMonetaryListOrderPrice"
                                                disabled={element?.UnidMedida === "UN" || element?.UnidMedida === "PC"? true : false}
                                                style={{
                                                    border: element?.UnidMedida === "UN" || element?.UnidMedida === "PC"? "1px solid transparent" : "",
                                                    width: "5rem"
                                                }}
                                                value={element.ValorTotal ?? "R$ 0,00"}
                                                onChange={(e) => {
                                                    e.target.value = normalizeNumberInput(e.target.value);

                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorTotal = e.target.value;
                                                    setOrder(orderAux);
                                                }}
                                                onFocus={(e) => {
                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorTotal =
                                                        parseMoney(e.target.value).toString().replace(".", ",");
                                                    setOrder(orderAux);
                                                }}
                                                onBlur={(e) => {
                                                    const total = parseMoney(e.target.value);

                                                    const qty = safeNumber(order[index].QuantidadeUM);
                                                    const desconto = parseMoney(order[index].ValorDesconto);
                                                    const bruto = total + desconto;
                                                    const unit = qty > 0 ? bruto / qty : 0;

                                                    const ipiFrac = parsePercentToFraction(order[index].PercentualIpi);

                                                    const orderAux = structuredClone(order);
                                                    orderAux[index].ValorTotal = `R$ ${total.toFixed(2).replace(".", ",")}`;
                                                    orderAux[index].ValorUnitario = `R$ ${unit.toFixed(2).replace(".", ",")}`;
                                                    orderAux[index].ValorTotalImp = (total + total * ipiFrac).toFixed(5);

                                                    setOrder(orderAux);
                                                }}
                                            />
                                        </td>

                                        {/* % ICMS */}
                                        <td>
                                            <input type="text"
                                                className='rowInputItemListOrderPrice' style={{ textAlign: "right" }}
                                                value={element?.PercentualIcms != null ? element?.PercentualIcms : 0}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                                    let value = e.target.value

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualIcms = value
                                                    setOrder(orderAux)
                                                }}
                                                onFocus={(e) => {
                                                    let orderAux = structuredClone(order)
                                                    let count = countChar(orderAux[index].PercentualIcms.toString(), "%")
                                                    orderAux?.map((element) => {
                                                        if (countChar(element.PercentualIpi.toString(), "%") == 0) {
                                                            element.PercentualIpi = `${element.PercentualIpi.toString().replace(".", ",")}%`
                                                        }
                                                        if (countChar(element.PercentualIcms.toString(), "%") == 0) {
                                                            element.PercentualIcms = `${element.PercentualIcms.toString().replace(".", ",")}%`
                                                        }
                                                    })
                                                    if (count == 0) {
                                                        orderAux[index].PercentualIcms = parseFloat(e.target.value.replace("%", ""))
                                                    }
                                                    else {
                                                        orderAux[index].PercentualIcms = parseFloat(e.target.value.replace("%", "").replaceAll('.', '').replaceAll(',', '.'))
                                                    }
                                                    setOrder(orderAux)
                                                }}
                                                onBlur={(e) => {
                                                    let value = e.target.value
                                                    let icms = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualIcms = `${icms.toFixed(2).replace(".", ",")}%`
                                                    setOrder(orderAux)
                                                }}
                                            />
                                        </td>

                                        {/* % IPI */}
                                        <td>
                                            <input type="text"
                                                className='rowInputItemListOrderPrice'
                                                value={element?.PercentualIpi != null ? element?.PercentualIpi : 0}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                                    let value = e.target.value
                                                    let ipi = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualIpi = value
                                                    let ValorTotal = parseFloat(orderAux[index].ValorTotal.replace("R$", "").replaceAll(".", "").replaceAll(",", "."))
                                                    orderAux[index].ValorTotalImp = parseFloat((parseFloat(ValorTotal) + ((parseFloat(ValorTotal)) * (ipi / 100)))).toFixed(2)
                                                    setOrder(orderAux)
                                                }}
                                                onFocus={(e) => {
                                                    let orderAux = structuredClone(order)
                                                    let count = countChar(orderAux[index].PercentualIpi.toString(), "%")
                                                    orderAux?.map((element) => {
                                                        if (countChar(element.PercentualIpi.toString(), "%") == 0) {
                                                            element.PercentualIpi = `${element.PercentualIpi.toString().replace(".", ",")}%`
                                                        }
                                                        if (countChar(element.PercentualIcms.toString(), "%") == 0) {
                                                            element.PercentualIcms = `${element.PercentualIcms.toString().replace(".", ",")}%`
                                                        }
                                                    })
                                                    if (count == 0) {
                                                        orderAux[index].PercentualIpi = parseFloat(e.target.value.replace("%", ""))
                                                    }
                                                    else {
                                                        orderAux[index].PercentualIpi = parseFloat(e.target.value.replace("%", "").replaceAll('.', '').replaceAll(',', '.'))
                                                    }
                                                    setOrder(orderAux)
                                                }}
                                                onBlur={(e) => {
                                                    let value = e.target.value
                                                    let ipi = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualIpi = `${ipi.toFixed(2).replace(".", ",")}%`
                                                    setOrder(orderAux)
                                                }}
                                            />
                                        </td>

                                        {/* % PIS */}
                                        <td>
                                            <input type="text"
                                                className='rowInputItemListOrderPrice' style={{ textAlign: "right" }}
                                                value={element?.PercentualPis != null ? element?.PercentualPis : 0}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                                    let value = e.target.value

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualPis = value
                                                    setOrder(orderAux)
                                                }}
                                                onFocus={(e) => {
                                                    let orderAux = structuredClone(order)
                                                    let count = countChar(orderAux[index].PercentualPis.toString(), "%")
                                                    orderAux?.map((element) => {
                                                        if (countChar(element.PercentualPis.toString(), "%") == 0) {
                                                            element.PercentualPis = `${element.PercentualPis.toString().replace(".", ",")}%`
                                                        }
                                                    })
                                                    if (count == 0) {
                                                        orderAux[index].PercentualPis = parseFloat(e.target.value.replace("%", ""))
                                                    }
                                                    else {
                                                        orderAux[index].PercentualPis = parseFloat(e.target.value.replace("%", "").replaceAll('.', '').replaceAll(',', '.'))
                                                    }
                                                    setOrder(orderAux)
                                                }}
                                                onBlur={(e) => {
                                                    let value = e.target.value
                                                    let pis = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualPis = `${pis.toFixed(2).replace(".", ",")}%`
                                                    setOrder(orderAux)
                                                }}
                                            />
                                        </td>

                                        {/* % COFINS */}
                                        <td>
                                            <input type="text"
                                                className='rowInputItemListOrderPrice' style={{ textAlign: "right" }}
                                                value={element?.PercentualCofins != null ? element?.PercentualCofins : 0}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')

                                                    let value = e.target.value

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualCofins = value
                                                    setOrder(orderAux)
                                                }}
                                                onFocus={(e) => {
                                                    let orderAux = structuredClone(order)
                                                    let count = countChar(orderAux[index].PercentualCofins.toString(), "%")
                                                    orderAux?.map((element) => {
                                                        if (countChar(element.PercentualCofins.toString(), "%") == 0) {
                                                            element.PercentualCofins = `${element.PercentualCofins.toString().replace(".", ",")}%`
                                                        }
                                                    })
                                                    if (count == 0) {
                                                        orderAux[index].PercentualCofins = parseFloat(e.target.value.replace("%", ""))
                                                    }
                                                    else {
                                                        orderAux[index].PercentualCofins = parseFloat(e.target.value.replace("%", "").replaceAll('.', '').replaceAll(',', '.'))
                                                    }
                                                    setOrder(orderAux)
                                                }}
                                                onBlur={(e) => {
                                                    let value = e.target.value
                                                    let cofins = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)

                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].PercentualCofins = `${cofins.toFixed(2).replace(".", ",")}%`
                                                    setOrder(orderAux)
                                                }}
                                            />
                                        </td>

                                        {/* DIMENSÃO */}
                                        <td>
                                            <input
                                                type="text"
                                                className='rowInputItemListOrderPrice'
                                                style={{ textAlign: "left", width: "fit-content" }}
                                                value={element?.DimensaoCot}
                                                onChange={(e) => {
                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].DimensaoCot = e.target.value
                                                    setOrder(orderAux)
                                                }}
                                            />
                                        </td>

                                        {/* DATA ENTREGA */}
                                        <td>
                                            <input className='rowInputDateItemListOrderPrice' type='date' value={
                                                element?.DataEntrega != null ?
                                                    element?.DataEntrega.split("T")[0].split('-')[0] + "-" + element?.DataEntrega.split("T")[0].split('-')[1] + "-" + element?.DataEntrega.split("T")[0].split('-')[2]
                                                    :
                                                    ""
                                            }
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    let orderAux = structuredClone(order)
                                                    orderAux[index].DataEntrega = e.target.value + "T00:00:00"
                                                    setOrder(orderAux)
                                                }} />
                                        </td>

                                        {/* OBS VENDEDOR */}
                                        <td className='rowItemIconListOrderPrice' style={{ textAlign: "left" }}>
                                            <div className='containerIconExpandObsOrderPrice' title='Expandir observações do vendedor' onClick={() => {
                                                setShowObsVendModal(true)
                                                setObsMatServ(element?.Descricao)
                                                setObsCodMatServ(element?.Codigo)
                                                setObsIndex(index)
                                            }}>
                                                <MdOutlineStickyNote2 className='iconExpandObsOrderPrice' size={18} />
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='containerGeneralInfoFieldsOrderPrice'>
                <div className='generalInfoTextOrderPrice'>Informações Gerais</div>
                <div className='containerGeneralFillOrderPrice'>
                    <div className='containerGeneralFillItensOrderPrice'>
                        <div className='containerGeneralFillInputOrderPrice'>
                            <div className='generalFillInputTextOrderPrice'>Desconto:</div>
                            <input
                                type="text"
                                className='generalFillInputInputOrderPrice'
                                value={generalDiscount}

                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) e.target.blur();
                                }}

                                onChange={(e) => {
                                    const value = e.target.value
                                        .replace(/[^0-9.,]/g, '')
                                        .replace(",", ".")
                                        .replace(/(\..*)\./g, '$1');

                                    setGeneralDiscount(value);
                                }}

                                onFocus={(e) => {
                                    const numeric = parseBRL(e.target.value);
                                    setGeneralDiscount(numeric.toFixed(2));
                                }}

                                onBlur={(e) => {
                                    const numeric = parseBRL(e.target.value);
                                    setGeneralDiscount(toBRL.format(numeric));
                                }}
                            />
                        </div>
                        <div className='containerGeneralFillInputOrderPrice'>
                            <div className='generalFillInputTextOrderPrice'>Frete:</div>
                            <input type="text"
                                className='generalFillInputInputOrderPrice'
                                value={generalTransport}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')
                                    let value = e.target.value
                                    setGeneralTransport(value)
                                }}
                                onFocus={(e) => {
                                    let value = parseFloat(e.target.value.replace("R$", "").replaceAll(".", "").replaceAll(",", "."))
                                    setGeneralTransport(value)
                                }}
                                onBlur={(e) => {
                                    let value = e.target.value
                                    let valueCheck = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)
                                    setGeneralTransport(toBRL.format(valueCheck.toFixed(2)))
                                }}
                            />
                        </div>
                        <div className='containerGeneralFillInputOrderPrice'>
                            <div className='generalFillInputTextOrderPrice'>Seguro:</div>
                            <input type="text"
                                className='generalFillInputInputOrderPrice'
                                value={generalInsurance}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')
                                    let value = e.target.value
                                    setGeneralInsurance(value)
                                }}
                                onFocus={(e) => {
                                    let value = parseFloat(e.target.value.replace("R$", "").replaceAll(".", "").replaceAll(",", "."))
                                    setGeneralInsurance(value)
                                }}
                                onBlur={(e) => {
                                    let value = e.target.value
                                    let valueCheck = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)
                                    setGeneralInsurance(toBRL.format(valueCheck.toFixed(2)))
                                }}
                            />
                        </div>
                        <div className='containerGeneralFillInputOrderPrice'>
                            <div className='generalFillInputTextOrderPrice'>Outros:</div>
                            <input type="text"
                                className='generalFillInputInputOrderPrice'
                                value={generalOther}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        e.target.blur();
                                    }
                                }}
                                onChange={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9.,]/g, '').replace(",", ".").replace(/(\..*)\./g, '$1')
                                    let value = e.target.value
                                    setGeneralOther(value)
                                }}
                                onFocus={(e) => {
                                    let value = parseFloat(e.target.value.replace("R$", "").replaceAll(".", "").replaceAll(",", "."))
                                    setGeneralOther(value)
                                }}
                                onBlur={(e) => {
                                    let value = e.target.value
                                    let valueCheck = isNaN(parseFloat(value)) ? 0.00 : parseFloat(value)
                                    setGeneralOther(toBRL.format(valueCheck.toFixed(2)))
                                }}
                            />
                        </div>
                        <div className='containerGeneralFillInputOrderPrice'>
                            <div className='generalFillInputTextOrderPrice'>Cond. Pag.:</div>
                            <select value={generalPayCond != null ? generalPayCond : 0} className='generalFillInputSelectOrderPrice' onChange={(e) => {
                                console.log(e.target.value)
                                setGeneralPayCond(e.target.value)
                            }}>
                                {generalPayCondArray?.map((payCond, index) => {
                                    return (
                                        <option key={"optionPayCond" + index} value={payCond.Id}>{payCond.Descricao}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className='containerGeneralFillInputOrderPrice'>
                            <div className='generalFillInputTextOrderPrice'>Tipo Frete:</div>
                            <select value={generalTransType != null ? generalTransType : 0} className='generalFillInputSelectOrderPrice' onChange={(e) => {
                                console.log(e.target.value)
                                setGeneralTransType(e.target.value)
                            }}>
                                {generalTransTypeArray?.map((transport, index) => {
                                    return (
                                        <option key={"optionTransport" + index} value={transport.Id}>{transport.Codigo} - {transport.Descricao}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className='containerGeneralInfoObservationOrderPrice'>
                <div className='containerObservationOrderPrice'>
                    <div className='observationTextOrderPrice'>Observações:</div>
                    <div className='containerObservationBoxOrderPrice'>
                        <div className='observationBoxOrderPrice'
                            contentEditable={true}
                            onClick={(e) => {
                                if (openedObservationBox) {
                                    setOpenedObservationBox(false)
                                    e.target.blur()
                                }
                                else {
                                    setOpenedObservationBox(true)
                                }
                            }}
                            onBlur={(e) => {
                                setOpenedObservationBox(false)
                                const text = e.target.innerHTML
                                    .replace(/<div>/g, '\r\n')
                                    .replace(/<\/div>/g, '')
                                    .replace(/<br>/g, '\r\n');
                                setObservation(text)
                            }}
                            dangerouslySetInnerHTML={{ __html: observation.replace(/\r\n/g, '<br>') }}
                            style={{ whiteSpace: 'pre-wrap' }} // Preserve espaços em branco
                        />
                    </div>
                </div>
            </div>
            <div className='containerSendOrderPrice'>
                <div className='containerGeneralInfoOrderPrice'>
                    <div className='containerTotalPriceOrderPrice'>
                        <div className='fieldGeneralInfoOrderPrice'>Preço total (com IPI):</div>
                        <div className='dataGeneralInfoOrderPrice'>{totalPriceGI}</div>
                    </div>
                    <div className='containerQtdOrderPrice'>
                        <div className='fieldGeneralInfoOrderPrice'>Quantidade de peças:</div>
                        <div className='dataGeneralInfoOrderPrice'>{totalPecasGI.toFixed(2)}</div>
                    </div>
                    <div className='containerLastDateOrderPrice'>
                        <div className='fieldGeneralInfoOrderPrice'>Última data de entrega:</div>
                        <div className='dataGeneralInfoOrderPrice'>{finalDateGI}</div>
                    </div>
                </div>
                <button className='buttonSendOrderPrice' title='Enviar Cotação' onClick={() => {
                    setShowSendModal(true)
                }}>Enviar cotação</button>
            </div>
            {showSendModal ?
                <div className='containerSendModalOrderPrice'>
                    <div className='containerSendModalConfirmationOrderPrice'>
                        <div className='headerSendModalOrderPrice'>
                            <div></div>
                            <div className='containerCloseButtonOrderPrice'>
                                <button className='closeButtonOrderPrice' onClick={() => { setShowSendModal(false) }}><CgClose className='closeButtonIconOrderPrice' size={24} /></button>
                            </div>
                        </div>
                        <div className='containerMessageSendModalOrderPrice'>
                            <div className='messageSendModalOrderPrice'>Deseja enviar/atualizar os dados do pedido?</div>
                        </div>
                        <div className='containerOptionsSendModalOrderPrice'>
                            <button className='optionContinueSendModalOrderPrice' onClick={() => { sendOrderDetails() }}>Continuar</button>
                            <button className='optionCancelSendModalOrderPrice' onClick={() => { setShowSendModal(false) }}>Cancelar</button>
                        </div>
                    </div>
                </div>
                :
                <>
                    {
                        showResponseModal ?
                            <ResponseModal data={{ message: responseModalMessage, type: responseModalType, closeModalFunc: setShowResponseModal }} />
                            :
                            <></>
                    }
                </>
            }
            {showResetModal ?
                <div className='containerSendModalOrderPrice'>
                    <div className='containerSendModalConfirmationOrderPrice'>
                        <div className='headerSendModalOrderPrice'>
                            <div></div>
                            <div className='containerCloseButtonOrderPrice'>
                                <button className='closeButtonOrderPrice' onClick={() => { setShowResetModal(false) }}><CgClose className='closeButtonIconOrderPrice' size={24} /></button>
                            </div>
                        </div>
                        <div className='containerMessageSendModalOrderPrice'>
                            <div className='messageSendModalOrderPrice'>Deseja resetar a tabela?</div>
                        </div>
                        <div className='containerOptionsSendModalOrderPrice'>
                            <button className='optionContinueSendModalOrderPrice' onClick={() => { resetTable() }}>Continuar</button>
                            <button className='optionCancelSendModalOrderPrice' onClick={() => { setShowResetModal(false) }}>Cancelar</button>
                        </div>
                    </div>
                </div>
                :
                <></>
            }
            {showObsVendModal ?
                <div className='containerObsModalOrderPrice'>
                    <div className='containerObsModalConfirmationOrderPrice'>
                        <div className='headerObsModalOrderPrice'>
                            <div className='containerObsInformationOrderPrice'>
                                <div className='obsInformationItemOrderPrice'><b>Material/Serviço: </b>{obsMatServ}</div>
                                <div className='obsInformationItemOrderPrice'><b>Cód. Mat./Serv.: </b>{obsCodMatServ}</div>
                            </div>
                            <div className='containerCloseButtonOrderPrice'>
                                <button className='closeButtonOrderPrice' onClick={() => { setShowObsVendModal(false); console.log(order) }}><CgClose className='closeButtonIconOrderPrice' size={24} /></button>
                            </div>
                        </div>
                        <div className='containerMessageObsModalOrderPrice'>
                            <div className='messageObsTitleOrderPrice'>Observações do Vendedor</div>
                            <textarea className='messageObsModalOrderPrice' onChange={(e) => {
                                let orderAux = structuredClone(order)
                                orderAux[obsIndex].ObservacoesItemVend = e.target.value
                                setOrder(orderAux)
                            }} value={order[obsIndex].ObservacoesItemVend}></textarea>
                        </div>
                    </div>
                </div>
                :
                <></>
            }
            {showObsCompModal ?
                <div className='containerObsModalOrderPrice'>
                    <div className='containerObsModalConfirmationOrderPrice'>
                        <div className='headerObsModalOrderPrice'>
                            <div className='containerObsInformationOrderPrice'>
                                <div className='obsInformationItemOrderPrice'><b>Material/Serviço: </b>{obsMatServ}</div>
                                <div className='obsInformationItemOrderPrice'><b>Cód. Mat./Serv.: </b>{obsCodMatServ}</div>
                            </div>
                            <div className='containerCloseButtonOrderPrice'>
                                <button className='closeButtonOrderPrice' onClick={() => { setShowObsCompModal(false); console.log(order) }}><CgClose className='closeButtonIconOrderPrice' size={24} /></button>
                            </div>
                        </div>
                        <div className='containerMessageObsModalOrderPrice'>
                            <div className='messageObsTitleOrderPrice'>Observações do Comprador</div>
                            <textarea className='messageObsModalOrderPrice' readOnly='True' onChange={(e) => {
                                let orderAux = structuredClone(order)
                                orderAux[obsIndex].ObservacoesItemComp = e.target.value
                                setOrder(orderAux)
                            }} value={order[obsIndex].ObservacoesItemComp}></textarea>
                        </div>
                    </div>
                </div>
                :
                <></>
            }
        </div>
    )
}